module.exports = __webpack_public_path__ + "static/media/doorway.9feb6150.svg";